import styled from "styled-components";
import { useBoundarySelectContext } from "./BoundarySelectContext";

const StatusContainer = styled.div`
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  background: white;
  padding: 6px 14px;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
  font-weight: 500;
  font-size: 1.4rem;
`;

const DrawingAreaStatus = () => {
  const { drawingAreaSqKm } = useBoundarySelectContext();

  if (drawingAreaSqKm === undefined) return null;

  return <StatusContainer>{drawingAreaSqKm.toFixed(2)} km²</StatusContainer>;
};

export default DrawingAreaStatus;
